import React from "react";
import { uniqBy } from "lodash";
import Creatable from "react-select/lib/Creatable";
import Select from "react-select";
import BaseField from './BaseField'
import AsyncSelect from 'react-select/lib/Async';


export default function SelectField(props){
  const { resource, name, label, optionValue, options = [], col, isMulti, onChange, value, action, creatable, loadOptions, placeholder, required, filterOption, isValidNewOption } = props;
  const FieldComponent = creatable ? Creatable : (loadOptions ? AsyncSelect : Select);

  return(
    <BaseField action={action} resource={resource} name={name} label={label} value={value} col={col} required={required} >
      <FieldComponent cacheOptions isClearable defaultOptions={options} filterOption={filterOption} isValidNewOption={isValidNewOption} isMulti={isMulti} value={optionValue} options={options} onChange={onChange} loadOptions={loadOptions} placeholder={placeholder} />
    </BaseField>
  )
}

export const getOptions = (state, ownProps) => {
  const { resource = "resident", name, options } = ownProps;
  const value = state[resource][name];

  if (Array.isArray(value)) {
    const optionValues = value.map((v) => {
      const option = options.find((o) => o.value === v);
      if (option) return option;
      return { label: v, value: v };
    });
    return uniqBy([...options, ...optionValues], "value")
  } else if (value) {
    const option = options.find((o) => o.value === value);
    if (option) {
      return uniqBy([...options, option], "value");
    }
    return uniqBy([...options, { label: value, value: value }], "value");
  }

  return options;
}

export const getOptionValue = (state, ownProps) => {
  const { resource = "resident", name } = ownProps;
  const value = state[resource][name];
  const options = getOptions(state, ownProps);

  if (Array.isArray(value)) {
    return value.map((v) => {
      return options.find((option) => option.value === v);
    })
  } else if (![null, undefined].includes(typeof value)) {
    return options.find((option) => option.value === value);
  }

  return null;
}

export const getValue = (state, ownProps) => {
  const optionValue = getOptionValue(state, ownProps);

  if (Array.isArray(optionValue) && optionValue.length > 0) {
    const mappedOptionValues = optionValue.map((o) => o.label);
    return mappedOptionValues.join(", ");
  } else if (optionValue) {
    return optionValue.label;
  }

  return null;
}